import React from "react";
import { fleetrifyIcons } from "../../../assets/icons/icons";

const AnalysisChartCard = ({
  children,
  headerTitle,
  subText,
}: {
  children?: React.ReactNode;
  headerTitle?: string;
  subText?: string;
}) => {
  return (
    <div className="h-full space-y-3 bg-[#F5F6FA] p-8 rounded-lg">
      <div className="flex justify-between items-start">
        <div className="space-y-1 mb-10">
          <h2 className="text-xl font-bold text-[#202224]">
            {headerTitle || "Revenue Vs. Expenses"}
          </h2>
          <p className="text-gray-500 text-[10px] italic">
            ({subText || "in millions"})
          </p>
        </div>
        <button className="!bg-white rounded-[3px] py-[8px] px-[13px] ">
          {fleetrifyIcons.ellipseIcon}
        </button>
      </div>
      {children}
    </div>
  );
};
export default AnalysisChartCard;
